import React, { FC, useState } from "react";
import { IReadMoreProps } from "types/components/readMore";

const ReadMore: FC<IReadMoreProps> = ({
  children,
  charactersToPreview = 150,
  dir = "ltr",
  lang = "en",
  className,
  readMoreColor = "",
}) => {
  const [hidden, setHidden] = useState<boolean>(true);

  return (
    <p dir={dir} lang={lang} className={className || ""}>
      {children.length > 150 ? (
        hidden ? (
          <>
            {children.slice(0, charactersToPreview)}...{" "}
            <span
              className={` cursor-pointer underline ${
                readMoreColor ?? "text-white lg:text-theme-purple"
              }`}
              color="#1a4e99"
              onClick={() => setHidden(!hidden)}
            >
              {lang === "en" ? "Read More" : "ראה עוד"}
            </span>
          </>
        ) : (
          <>{children}</>
        )
      ) : (
        children
      )}
    </p>
  );
};

export default ReadMore;
